import { c as _c } from "react/compiler-runtime";
import Text from '../base/Text';
import { Div } from '../helpers/StyledUtils';
interface NoDataChartProps {
  height?: number;
}
const NoDataChart: React.FC<NoDataChartProps> = t0 => {
  const $ = _c(6);
  const {
    height: t1
  } = t0;
  const height = t1 === undefined ? 260 : t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      position: "relative"
    };
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  let t3;
  if ($[1] !== height) {
    t3 = {
      px: height
    };
    $[1] = height;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <Div style={{
      position: "absolute",
      inset: 0
    }} flex={{
      align: "center",
      justify: "center"
    }}><Text neutral={true} semi={true}>No data to display.</Text></Div>;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] !== t3) {
    t5 = <Div style={t2} h={t3}>{t4}</Div>;
    $[4] = t3;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  return t5;
};
export default NoDataChart;